import { ModuleId } from 'admin/modules/Modules';

export enum RouteType {
    Add = 'add',
    Edit = 'edit',
}

export enum LabelSource {
    System = 1,
    DataScience = 2,
    User = 3,
}

export enum FieldName {
    Name = 'name',
    Color = 'color',
    Active = 'label.active',
    Id = 'label.id',
}

export interface Label {
    id?: number;
    agencyID?: number;
    tenantID?: number;
    createdDate?: Date;
    updatedDate?: Date;
    name: string;
    description?: string;
    parentID?: string;
    moduleIDs: string[];
    labelSource?: LabelSource; // readonly
    order?: number;
    color?: string;
    active: boolean;
    displayName?: string;
}

export interface LabelValue {
    label: string;
    value: string;
    disabled?: boolean;
}

export interface Role {
    id: number;
    name: string;
}

export const Modules: Record<string, LabelValue> = {
    Customers: {
        label: 'CUSTOMERS',
        value: ModuleId.PlatformCustomers,
    },
    Messaging: {
        label: 'MESSAGING',
        value: ModuleId.MessagingInbox,
    },
    Reviews: {
        label: 'REVIEWS',
        value: ModuleId.ReviewMonitoring,
    },
    Social: {
        label: 'SOCIAL',
        value: ModuleId.SocialInbox,
    },
    Surveys: {
        label: 'SURVEYS',
        value: ModuleId.Survey,
    },
};

export interface LabelError {
    code: string;
    field: string;
    message: string;
    value?: string;
}
